var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_app_loading)?_c('div',{staticClass:"the-loading-page"},[_c('div',{class:['the-loading-icon '+_vm.is_app_loading]})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }